export let ActionTypes;

(function (ActionTypes) {
  ActionTypes["blur"] = "blur";
  ActionTypes["focus"] = "focus";
  ActionTypes["keyDown"] = "keyDown";
  ActionTypes["optionClick"] = "optionClick";
  ActionTypes["setControlledValue"] = "setControlledValue";
  ActionTypes["optionsChange"] = "optionsChange";
})(ActionTypes || (ActionTypes = {}));